export function getMcrGlossaryStaticLinkHtml(label, content) {
  // can not reuse class `glossary` as it breaks the popup
  return `<a data-mcr-content="${content}" class="glossary-static">${label}</a>`;
}
